
import { createRoot } from 'react-dom/client'
import * as Sentry from "@sentry/react";
import App from './App.tsx'
import './index.css'

// Initialize Sentry as early as possible
Sentry.init({
  dsn: "https://4cbf7de630269462e2ade02c442e51a5@o4509122814541824.ingest.us.sentry.io/4509485083328512",
  environment: import.meta.env.MODE,
  release: import.meta.env.npm_package_version || "1.0.0",
  integrations: [
    Sentry.browserTracingIntegration({
      // Capture interactions like clicks, form submissions, and navigation
      enableInp: true,
    }),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
    // Automatically capture console logs
    Sentry.consoleLoggingIntegration({ 
      levels: ["log", "error", "warn", "info"] 
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: import.meta.env.MODE === 'development' ? 1.0 : 0.1,
  // Session Replay
  replaysSessionSampleRate: import.meta.env.MODE === 'development' ? 1.0 : 0.1,
  replaysOnErrorSampleRate: 1.0,
  // Setting this option to true will send default PII data to Sentry.
  sendDefaultPii: true,
  // Enable logging experiments
  _experiments: {
    enableLogs: true,
  },
  // Enhanced error context
  beforeSend(event) {
    // Add additional context to errors
    if (event.exception) {
      const error = event.exception.values?.[0];
      if (error) {
        event.tags = {
          ...event.tags,
          errorBoundary: event.contexts?.react?.componentStack ? 'true' : 'false',
        };
      }
    }
    return event;
  },
});

createRoot(document.getElementById("root")!).render(<App />);
